// v-autogrow="maxRows"
// Makes a textarea grow with its content, from its `rows` attribute up to maxRows lines.
// Above maxRows the textarea gets a scrollbar instead of growing further.
// Recalculates when the user types, when v-model changes the value (e.g. loading an existing item)
// and when the textarea becomes visible or changes width (e.g. hidden tab shown, window resized).

const DEFAULT_MAX_ROWS = 20

function resize (el) {
    // Hidden (display: none) - nothing to measure yet. The ResizeObserver resizes it once it is shown.
    if (!el.offsetParent && el.offsetWidth === 0) {
        return
    }

    const style = window.getComputedStyle(el)
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2
    const padding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)
    const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth)
    const maxRows = el._autogrowMaxRows

    // Reset first so the textarea can also shrink when text is removed
    el.style.height = 'auto'

    const contentHeight = el.scrollHeight // includes padding, excludes border
    const maxContentHeight = lineHeight * maxRows + padding
    const targetHeight = Math.min(contentHeight, maxContentHeight)

    el.style.height = (style.boxSizing === 'border-box' ? targetHeight + border : targetHeight - padding) + 'px'
    el.style.overflowY = contentHeight > maxContentHeight ? 'auto' : 'hidden'
}

export default {
    inserted (el, binding) {
        el._autogrowMaxRows = Number(binding.value) || DEFAULT_MAX_ROWS
        el._autogrowResize = () => resize(el)
        el.addEventListener('input', el._autogrowResize)

        if (window.ResizeObserver) {
            // Only react to width changes; height changes are caused by resize() itself
            let lastWidth = el.offsetWidth
            el._autogrowObserver = new ResizeObserver(() => {
                if (el.offsetWidth !== lastWidth) {
                    lastWidth = el.offsetWidth
                    resize(el)
                }
            })
            el._autogrowObserver.observe(el)
        }

        resize(el)
    },
    componentUpdated (el, binding) {
        el._autogrowMaxRows = Number(binding.value) || DEFAULT_MAX_ROWS
        // Wait for v-model to write the new value to the textarea
        Promise.resolve().then(() => resize(el))
    },
    unbind (el) {
        el.removeEventListener('input', el._autogrowResize)
        if (el._autogrowObserver) {
            el._autogrowObserver.disconnect()
        }
    }
}



// WEBPACK FOOTER //
// ./src/directives/autogrow.js